import { images } from "../../../Assets/assetsHelper";
import "./CourseDetails.css";
import React, { useContext, useEffect, useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { userContext } from "../../../Contexts/userContext";
import TextArea from "../../../Components/Atoms/Inputs/TextArea/TextArea";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import { MoonLoader } from "react-spinners";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import PreviewIcon from "@mui/icons-material/Preview";
import useDelete from "../../../Hooks/useDelete";
import FilePreviewModal from "../../../Components/Organisms/FilePreviewModal/FilePreviewModal";
import { courseURL, BaseURL } from "../../../Hooks/URL";

function CourseDetails({ course, setCourse, url, setGo, loading, lessons }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const [unassignGo, setUnassignGo] = useState(false);
  const [schoolToUnassign, setSchoolToUnassign] = useState(null);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const unassignUrl = course?.id ? `${courseURL}/${course.id}/schools` : null;

  const { deleteRes } = useDelete(
    unassignUrl,
    unassignGo,
    null,
    null,
    null,
    {
      schoolIds: schoolToUnassign ? [schoolToUnassign] : [],
    },
    true
  );

  // Handle successful unassign
  useEffect(() => {
    if (deleteRes && schoolToUnassign) {
      setSchoolToUnassign(null);
      setUnassignGo(false);
    }
  }, [deleteRes, schoolToUnassign, course, setCourse]);

  const handleUnassignSchool = async (schoolId) => {
    try {
      setSchoolToUnassign(schoolId);
      setUnassignGo(true);
    } catch (error) {
      console.error("Error unassigning school:", error);
      alert("Failed to unassign school. Please try again.");
      setUnassignGo(false);
      setSchoolToUnassign(null);
    }
  };

  const handleDownloadAttachment = (attachment) => {
    // Create download link for the attachment
    const downloadUrl = `${BaseURL}/${attachment.filePath}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = attachment.name || "attachment";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle preview functionality for attachments
  const handlePreviewAttachment = (attachment) => {
    setPreviewAttachment(attachment);
    setIsPreviewOpen(true);
  };

  // Close preview
  const closePreview = () => {
    setPreviewAttachment(null);
    setIsPreviewOpen(false);
  };

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {course && (
        <>
          {/* Action Buttons */}
          {contextData?.role == "admin" && (
            <div className="courseActions">
              <button
                className="actionButton primary"
                onClick={() => navigate(`/programs/add/${course.id}`)}
              >
                Edit Program
              </button>
              <DeleteForm
                setGo={setGo}
                title={"Are you sure to delete this program?"}
              />
            </div>
          )}

          {/* Course Header Section */}
          <div className="contentSection">
            <div className="courseHeader">
              <div className="courseIconSection">
                <div className="titleIcon">
                  <MenuBookIcon />
                </div>
              </div>
              <div className="courseBasicInfo">
                <h1 className="courseName">{course.title}</h1>
              </div>

              <div className="courseStats">
                {contextData?.role == "admin" && (
                  <div
                    className="statItem clickable"
                    onClick={() => {
                      const schoolsSection = document.getElementById("schools");
                      schoolsSection?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    <SchoolIcon className="statIcon" />
                    <span className="statLabel">Assigned Schools</span>
                    <span className="statValue">
                      {course.schools?.length || 0}
                    </span>
                  </div>
                )}
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const lessonsSection = document.getElementById("lessons");
                    lessonsSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <MenuBookIcon className="statIcon" />
                  <span className="statLabel">Lessons</span>
                  <span className="statValue">{lessons?.length || 0}</span>
                </div>
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const attributesSection =
                      document.getElementById("attributes");
                    attributesSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AssessmentIcon className="statIcon" />
                  <span className="statLabel">Attributes</span>
                  <span className="statValue">
                    {course.attributes?.length || 0}
                  </span>
                </div>
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const attachmentsSection =
                      document.getElementById("attachments");
                    attachmentsSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AttachFileIcon className="statIcon" />
                  <span className="statLabel">Attachments</span>
                  <span className="statValue">
                    {course.attachments?.length || 0}
                  </span>
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">Program Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">
                  <DescriptionIcon className="infoIcon" />
                  Description
                </div>
                <div className="infoValue descriptionText">
                  {course.description || "No description available"}
                </div>
              </div>
            </div>
          </div>

          {/* Lessons Section */}
          <div className="contentSection" id="lessons">
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Program Lessons</h2>
              {contextData?.role == "admin" && (
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/programs/${course.id}/lessons/add`)}
                >
                  <AddIcon />
                  Add Lesson
                </button>
              )}
            </div>

            {/* Lessons Grid */}
            {lessons && lessons.length > 0 ? (
              <div className="lessonsGrid">
                {lessons?.map((lesson, index) => (
                  <div key={index} className="lessonCard">
                    <div className="lessonHeader">
                      <div className="lessonIcon">
                        <MenuBookIcon />
                      </div>
                      <div className="lessonInfo">
                        <h4 className="lessonTitle">{lesson.title}</h4>
                        <p className="lessonSession">Lesson {lesson.number}</p>
                      </div>
                    </div>

                    <div className="lessonContent">
                      <p className="lessonDescription">
                        {lesson.content && lesson.content.length > 100
                          ? `${lesson.content.substring(0, 100)}...`
                          : lesson.content || "No content available"}
                      </p>
                    </div>

                    <div className="lessonFooter">
                      <button
                        className="viewLessonButton"
                        onClick={() =>
                          navigate(
                            `/programs/${course.id}/lessons/${lesson.id}`
                          )
                        }
                        title="View lesson details"
                      >
                        <VisibilityIcon />
                        View Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <MenuBookIcon className="emptyIcon" />
                <h3>No Lessons Available</h3>
                <p>This program doesn't have any lessons yet.</p>
                {contextData?.role == "admin" && (
                  <button
                    className="actionButton primary"
                    onClick={() =>
                      navigate(`/programs/${course.id}/lessons/add`)
                    }
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add First Lesson
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Assigned Schools Section */}
          {contextData?.role == "admin" && (
            <div className="contentSection assigntoSchool" id="schools">
              <div className="lessonsHeader">
                <h2 className="sectionTitle">Program Assigned Schools</h2>
                {contextData?.role == "admin" && (
                  <button
                    className="actionButton primary"
                    onClick={() => navigate(`/programs/assign/${course.id}`)}
                  >
                    <AddIcon />
                    Assign Schools
                  </button>
                )}
              </div>
              {course.schools && course.schools.length > 0 ? (
                <div className="schoolsGrid">
                  {course?.schools?.map((school, index) => (
                    <div key={index} className="schoolCard">
                      <div
                        className="schoolCardContent"
                        onClick={() => navigate(`/schools/${school.id}`)}
                      >
                        <div className="schoolLogoSection">
                          {school.logo ? (
                            <img
                              src={`${
                                process.env.REACT_APP_BASE_URL ||
                                "https://apistaging.skill-code.com"
                              }${school.logo}`}
                              alt={`${school.name} Logo`}
                              className="schoolLogo"
                            />
                          ) : (
                            <div className="schoolLogoPlaceholder">
                              <BusinessIcon />
                            </div>
                          )}
                        </div>
                        <div className="schoolInfo">
                          <h4 className="schoolName">{school.name}</h4>
                        </div>
                      </div>
                      {contextData?.role == "admin" && (
                        <>
                          <DeleteForm
                            icon
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUnassignSchool(school.id);
                            }}
                            title={
                              "Are you sure to unassign this school from this program?"
                            }
                          />
                        </>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="emptyState">
                  <BusinessIcon className="emptyIcon" />
                  <h3>No Schools Assigned</h3>
                  <p>This program is not assigned to any schools yet.</p>
                  {contextData?.role == "admin" && (
                    <button
                      className="actionButton primary"
                      onClick={() => navigate(`/programs/assign/${course.id}`)}
                      style={{ margin: "20px auto" }}
                    >
                      <AddIcon />
                      Assign Schools
                    </button>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Attributes Section */}
          <div className="contentSection" id="attributes">
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Program Feedback Standards</h2>
              {contextData?.role == "admin" && (
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/programs/${course.id}/attributes`)}
                >
                  <AddIcon />
                  Add Feedback Standards
                </button>
              )}
            </div>
            {course.attributes && course.attributes.length > 0 ? (
              <div className="attributesGrid">
                {course.attributes.map((attribute, index) => (
                  <div key={index} className="attributeCard">
                    <div className="attributeNumber">{index + 1}</div>
                    <div className="attributeContent">
                      <h4 className="attributeName">{attribute.attribute}</h4>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <BusinessIcon className="emptyIcon" />
                <h3>No Feedback Attributes</h3>
                <p>
                  This program is not assigned to any feedback standards yet.
                </p>
                {contextData?.role == "admin" && (
                  <button
                    className="actionButton primary"
                    onClick={() =>
                      navigate(`/programs/${course.id}/attributes`)
                    }
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add Feedback Standards
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Attachments Section */}
          <div className="contentSection" id="attachments">
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Program Attachments</h2>
              {contextData?.role == "admin" && (
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/programs/add/${course.id}/`)}
                >
                  <AddIcon />
                  Add Attachments
                </button>
              )}
            </div>
            {course.attachments && course.attachments.length > 0 ? (
              <div className="attachmentsGrid">
                {course.attachments.map((attachment, index) => (
                  <div key={index} className="attachmentCard">
                    <div className="attachmentIcon">
                      <AttachFileIcon />
                    </div>
                    <div className="attachmentInfo">
                      <h4 className="attachmentName">{attachment.name}</h4>
                    </div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        className="actionButton secondary"
                        onClick={() => handlePreviewAttachment(attachment)}
                        title="Preview attachment"
                        style={{
                          padding: "12px",
                          minWidth: "auto",
                          fontSize: "18px",
                          background: "rgba(59, 130, 246, 0.1)",
                          color: "#3b82f6",
                          border: "1px solid rgba(59, 130, 246, 0.2)",
                        }}
                      >
                        <PreviewIcon />
                      </button>
                      {contextData?.role == "admin" && (
                        <button
                          className="actionButton primary"
                          onClick={() => handleDownloadAttachment(attachment)}
                          title="Download attachment"
                          style={{
                            padding: "12px",
                            minWidth: "auto",
                            fontSize: "18px",
                          }}
                        >
                          <DownloadIcon />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <BusinessIcon className="emptyIcon" />
                <h3>No Attachments</h3>
                <p>This program is not assigned to any attachments yet.</p>
                {contextData?.role == "admin" && (
                  <button
                    className="actionButton primary"
                    onClick={() => navigate(`/programs/add/${course.id}/`)}
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add Attachments
                  </button>
                )}
              </div>
            )}
          </div>
        </>
      )}

      {/* File Preview Modal */}
      <FilePreviewModal
        attachment={previewAttachment}
        isOpen={isPreviewOpen}
        onClose={closePreview}
        baseURL={BaseURL}
      />
    </div>
  );
}

export default CourseDetails;
